import React, { useState } from 'react';

const WaitingListPage = () => {
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState('');

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
  
    if (!email) {
      setMessage('Please enter a valid email address.');
      setShowMessage(true);
      return;
    }
  
    try {
      const response = await fetch('/.netlify/functions/waitList', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
  
      if (response.ok) {
        try {
          // Removed unused 'data' variable
          await response.json();
          setMessage(`Thank you for joining the waiting list, ${email}!<br />You will immediately be notified when we launch.`);
        } catch (jsonError) {
          console.error('Error parsing JSON response:', jsonError);
          setMessage('Something went wrong. Please try again later.');
        }
      } else {
        const errorText = await response.text();
        console.error('Backend error:', errorText);
        setMessage('Something went wrong. Please try again later.');
      }
    } catch (error) {
      console.error('Error submitting email:', error);
      setMessage('An error occurred. Please try again later.');
    }
  
    setShowMessage(true);
    e.target.reset(); // Clear the form
  };

  return (
    <div className="bg-gray-50 text-gray-900 w-screen h-screen">
      <header className="relative bg-gradient-to-r from-teal-500 to-blue-600 text-white">
        <div className="container mx-auto px-6 py-16 text-center">
          <h1 className="text-4xl md:text-6xl font-bold leading-tight">
            Coming soon - Unlock Your Creativity with AI
          </h1>
          <p className="mt-4 text-lg md:text-2xl">
            Generate stunning designs and marketing materials with ease.
          </p>
          <p className="mt-4 text-md md:text-xl font-semibold">
            Join our waiting list and get notified with a launch date, early access, and a discounted subscription!
          </p>
          <form
            className="mt-4 inline-block"
            onSubmit={handleFormSubmit}
          >
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              className="px-4 py-2 rounded-l-lg border border-gray-300 focus:outline-none focus:border-blue-500"
              required
            />
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white font-semibold rounded-r-lg shadow hover:bg-blue-600 focus:outline-none"
            >
              Get Early Access
            </button>
          </form>
          {showMessage && (
              <span className='flex justify-center items-center mt-4'>
                <p className="w-fit bg-green-500 px-4 py-2 text-white font-semibold"
                dangerouslySetInnerHTML={{ __html: message }}
                ></p>
                </span>
           )}
        </div>
      </header>

      {/* Features Section */}
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-8">Features</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-6 bg-white rounded-lg shadow-lg text-center">
              <h3 className="text-xl font-semibold mb-4">AI-Powered Designs</h3>
              <p>
                Leverage cutting-edge AI technology to create professional-grade
                designs in seconds.
              </p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-lg text-center">
              <h3 className="text-xl font-semibold mb-4">Customizable Templates</h3>
              <p>
                Choose from a variety of templates tailored to your industry and
                style.NextLandingPage
                Our intuitive interface makes it simple for anyone to create
                stunning visuals.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-teal-500 text-white">
        <div className="container mx-auto px-6 text-center">
        <form
            className="mt-4 inline-block"
            onSubmit={handleFormSubmit}
          >
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              className="px-4 py-2 rounded-l-lg border border-gray-300 focus:outline-none focus:border-blue-500"
              required
            />
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white font-semibold rounded-r-lg shadow hover:bg-blue-600 focus:outline-none"
            >
              Get Early Access
            </button>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 bg-gray-800 text-gray-400">
        <div className="container mx-auto px-6 text-center">
          <p>&copy; 2025 NextNoetics. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default WaitingListPage;